// import React, { useEffect, useRef, useState } from "react";
// const BookingReport = ({ reservation }) => {
//   console.log(reservation);
//   const reportRef = useRef();
//   const [addedServices, setAddedServices] = useState([]);
//   const [newItem, setNewItem] = useState({
//     type: "",
//     item: "",
//     desc: "",
//     quantity: 1,
//     rate: 0,
//     tax: 0,
//   });
//   const handleAddService = () => {
//     if (!newItem.type || !newItem.item) {
//       alert("Please enter Type and Item");
//       return;
//     }
//     setAddedServices([...addedServices, { ...newItem }]);
//     setNewItem({
//       type: "",
//       item: "",
//       desc: "",
//       quantity: 1,
//       rate: 0,
//       tax: 0,
//     });
//   };
//   const openReportInNewTab = () => {
//     const newWindow = window.open("/report.html", "_blank");
//     const reportContent = reportRef.current.innerHTML;
//     newWindow.document.write(`
//       <html>
//         <head>
//           <title>Invoice</title>
//           <style>
//             body {
//               font-family: Arial, sans-serif;
//               margin: 0;
//               padding: 20px;
//               background: #fff;
//               color: #333;
//               line-height: 1.5;
//               font-size: 14px;
//             }
//             .card {
//               border: 1px solid #ddd;
//               border-radius: 10px;
//               padding: 25px;
//               background: #f9f9f9;
//               max-width: 900px;
//               margin: auto;
//             }
//             .hotel-grid {
//               display: flex;
//               gap: 20px;
//               align-items: center;
//               margin-bottom: 25px;
//             }
//             .hotel-grid-item1 img {
//               max-width: 130px;
//               border-radius: 10px;
//             }
//             .hotel-grid-item2 div {
//               margin: 4px 0;
//             }
//             h6 {
//               font-size: 16px;
//               margin-bottom: 10px;
//               font-weight: bold;
//               color: #4CBC9A;
//             }
//             table {
//               width: 100%;
//               border-collapse: collapse;
//               margin-bottom: 20px;
//               font-size: 13px;
//             }
//             table th, table td {
//               border: 1px solid #ddd;
//               padding: 10px;
//               text-align: left;
//             }
//             table th {
//               background: #4CBC9A;
//               color: white;
//               font-size: 14px;
//             }
//             .summary {
//               text-align: right;
//               font-weight: bold;
//               margin-top: 15px;
//               font-size: 14px;
//             }
//             .signature {
//               text-align: center;
//               width: 200px;
//               border-top: 1px solid #000;
//               margin-top: 40px;
//               font-size: 13px;
//               padding-top: 5px;
//             }
//             .download-btn {
//               display: inline-block;
//               margin-top: 20px;
//               padding: 10px 20px;
//               background: #4CBC9A;
//               color: #fff !important;
//               border: none;
//               border-radius: 5px;
//               cursor: pointer;
//               text-decoration: none;
//               font-size: 16px;
//               font-weight: bold;
//             }
//             .guest-info div {
//               margin: 3px 0;
//             }
//           </style>
//         </head>
//         <body>
//           <div class="card">
//             ${reportContent}
//             <div style="text-align:center; margin-top: 20px;">
//               <button onclick="window.print()" class="download-btn">Print / Download</button>
//             </div>
//           </div>
//         </body>
//       </html>
//     `);
//     newWindow.document.close();
//   };
//   const calculateTotal = () => {
//     const roomTotal = reservation.roomDetails?.reduce(
//       (sum, r) => sum + Number(r.roomTotalPrice || 0),
//       0
//     );
//     const servicesTotal = addedServices.reduce(
//       (sum, s) => sum + s.quantity * s.rate + Number(s.tax || 0),
//       0
//     );
//     return roomTotal + servicesTotal;
//   };
//   useEffect(() => {
//     if (reservation) openReportInNewTab();
//   }, [reservation]);
//   return (
//     <div ref={reportRef} style={{ display: "none" }}>
//       {/* Hotel Info */}
//       <div className="hotel-grid">
//         <div className="hotel-grid-item1">
//           <img src={reservation.image || ""} alt="Hotel" />
//         </div>
//         <div className="hotel-grid-item2">
//           <div style={{ fontSize: "16px", fontWeight: "bold" }}>
//             {reservation.hotelName}
//           </div>
//           <div>{reservation.address}</div>
//           <div>
//             {reservation.phone} | {reservation.email}
//           </div>
//         </div>
//       </div>
//       {/* Guest Info */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginBottom: "25px",
//         }}
//         className="guest-info"
//       >
//         <div>
//           <b>Billed To:</b>
//           <div>
//             {reservation.firstName} {reservation.lastName}
//           </div>
//           <div>{reservation.mobile}</div>
//           <div>{reservation.email}</div>
//           <div>{reservation.address}</div>
//         </div>
//         <div>
//           <div>Check-in: {reservation.checkIn}</div>
//           <div>Check-out: {reservation.checkOut}</div>
//         </div>
//       </div>
//       {/* Charges Table */}
//       <h6>Charges</h6>
//       <table>
//         <thead>
//           <tr>
//             <th>Sr#</th>
//             {/* <th>Type</th> */}
//             <th>Item</th>
//             {/* <th>Description</th> */}
//             <th>Quantity</th>
//             <th>Rate</th>
//             <th>Nights</th>
//             <th>Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           {reservation.roomDetails?.map((room, idx) => (
//             <tr key={idx}>
//               <td>{idx + 1}</td>
//               {/* <td>{room.planName}</td> */}
//               <td>
//                 {room.name} ({room.planName})
//               </td>
//               {/* <td>{room.description || "-"}</td> */}
//               <td>{room.quantity}</td>
//               <td>Rs {room.rate[0]?.ratePerNight}</td>
//               <td>{reservation.noOfDays} Night</td>
//               <td>Rs {room.roomTotalPrice}</td>
//               {/* <td>Rs {room.roomTotalTax}</td> */}
//             </tr>
//           ))}
//           {addedServices.map((s, idx) => (
//             <tr key={idx + reservation.roomDetails.length}>
//               <td>{idx + 1 + reservation.roomDetails.length}</td>
//               <td>{s.type}</td>
//               <td>{s.item}</td>
//               <td>{s.desc}</td>
//               <td>{s.quantity}</td>
//               <td>{s.rate}</td>
//               <td>-</td>
//               <td>{s.quantity * s.rate}</td>
//               <td>{s.tax}</td>
//             </tr>
//           ))}
//         </tbody>
//         <tfoot>
//           <tr>
//             <td>Add New</td>
//             <td>
//               <input
//                 type="text"
//                 placeholder="Type"
//                 value={newItem.type}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, type: e.target.value })
//                 }
//                 style={{ width: "100%" }}
//               />
//             </td>
//             <td>
//               <input
//                 type="text"
//                 placeholder="Item"
//                 value={newItem.item}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, item: e.target.value })
//                 }
//                 style={{ width: "100%" }}
//               />
//             </td>
//             <td>
//               <input
//                 type="text"
//                 placeholder="Description"
//                 value={newItem.desc}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, desc: e.target.value })
//                 }
//                 style={{ width: "100%" }}
//               />
//             </td>
//             <td>
//               <input
//                 type="number"
//                 placeholder="Quantity"
//                 value={newItem.quantity}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, quantity: Number(e.target.value) })
//                 }
//                 style={{ width: "80px" }}
//               />
//             </td>
//             <td>
//               <input
//                 type="number"
//                 placeholder="Rate"
//                 value={newItem.rate}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, rate: Number(e.target.value) })
//                 }
//                 style={{ width: "80px" }}
//               />
//             </td>
//             <td>-</td>
//             <td>{newItem.quantity * newItem.rate}</td>
//             <td>
//               <input
//                 type="number"
//                 placeholder="Tax"
//                 value={newItem.tax}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, tax: Number(e.target.value) })
//                 }
//                 style={{ width: "80px" }}
//               />
//             </td>
//             <td>
//               <button
//                 type="button"
//                 onClick={handleAddService}
//                 style={{
//                   padding: "5px 10px",
//                   backgroundColor: "#4CBC9A",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Add
//               </button>
//             </td>
//           </tr>
//         </tfoot>
//       </table>
//       {/* Summary */}
//       <div className="summary">
//         {/* <div>Amount: Rs {reservation.totalPrice}</div> */}
//         <div>Total Tax: Rs {reservation.taxes}</div>
//         <div>
//           Total Amount: Rs{" "}
//           {Number(reservation.totalPrice) + Number(reservation.taxes)}
//         </div>
//         {/* <div>Discount: Rs {reservation.discount}</div>
//         <div>Paid: Rs {reservation.paid}</div>
//         <div>Balance: Rs {reservation.balance}</div> */}
//       </div>
//       {/* Signature */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-evenly",
//           marginTop: "50px",
//         }}
//       >
//         <div className="signature">Guest</div>
//         <div className="signature">Cashier</div>
//       </div>
//     </div>
//   );
// };
// export default BookingReport;
import React, { useEffect, useState, useRef } from "react";

import {
  getHotelProducts,
  getHotelServices,
  getReservationById,
  updateContent,
} from "../../../FIREBASECONFIG";

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "20px",
  fontFamily: "Arial, sans-serif",
};

const thStyle = {
  border: "1px solid #ccc",
  padding: "8px",
  fontSize: "13px",
  backgroundColor: "#4CBC9A",
  color: "#fff",
  fontWeight: "bold",
  textAlign: "left",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "8px",
  fontSize: "13px",
  textAlign: "left",
};

const inputStyle = { width: "100%", padding: "4px", boxSizing: "border-box" };

const signatureStyle = {
  textAlign: "center",
  width: "200px",
  borderTop: "1px solid #000",
  marginTop: "40px",
};
const smallInputStyle = {
  width: "80px",
  padding: "4px",
  boxSizing: "border-box",
};

const buttonStyle = {
  padding: "5px 10px",
  backgroundColor: "#4CBC9A",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
};

const BookingReportPage = () => {
  const [servicesTypes, setServicesTypes] = useState([]); // e.g., ['Bedding', 'Food']
  const [itemsList, setItemsList] = useState([]); // Products/services for selected type
  const [allItems, setAllItems] = useState([]); // store all services + products

  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [addedServices, setAddedServices] = useState([]);
  const [totalServicesPrice, setTotalServicesPrice] = useState(0);
  const recalculateTotal = (services) => {
    const total = services.reduce(
      (sum, s) => sum + s.quantity * s.rate + (s.tax || 0),
      0
    );
    setTotalServicesPrice(total);
  };

  const [newItem, setNewItem] = useState({
    type: "",
    item: "",
    desc: "",
    quantity: 1,
    rate: 0,
    tax: 0,
  });

  const reportRef = useRef();
  useEffect(() => {
    // Fetch all services/products for the hotel
    const fetchTypes = async () => {};

    fetchTypes();
  }, []);

  // ---------------------------
  // Get bookingId from URL
  // ---------------------------
  const getBookingIdFromURL = () =>
    new URLSearchParams(window.location.search).get("id");

  // ---------------------------
  // Fetch Reservation from Firebase
  // ---------------------------
  const fetchBooking = async () => {
    const bookingId = getBookingIdFromURL();
    if (!bookingId) return;

    const data = await getReservationById(bookingId);
    if (!data) {
      console.error("Booking not found");
      setLoading(false);
      return;
    }

    console.log(data);
    setReservation(data);

    // Fetch hotel services and products
    const services = await getHotelServices(data.hotelId);
    const products = await getHotelProducts(data.hotelId);
    console.log(services);
    console.log(products);

    // Store all items for later filtering
    setAllItems(products);
    setServicesTypes(services);
    setTotalServicesPrice(data.totalServicesPrice || 0);
    setAddedServices(data.addedServices || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchBooking();
  }, []);

  const handleTypeChange = (selectedTypeId) => {
    setNewItem({ ...newItem, type: selectedTypeId, item: "" });

    // Filter products for this type
    const filteredItems = allItems.filter(
      (product) => product.typeId === selectedTypeId
    );

    setItemsList(filteredItems);
  };

  // ---------------------------
  // Add Service Row
  // ---------------------------
  const handleAddService = () => {
    if (!newItem.type || !newItem.item) {
      alert("Please fill Type & Item");
      return;
    }

    const selectedType = servicesTypes.find((t) => t.id === newItem.type);
    const selectedItem = itemsList.find((i) => i.id === newItem.item);
    if (!selectedType || !selectedItem) return;

    const added = {
      type: selectedType.type,
      typeId: selectedType.id,
      item: selectedItem.name,
      itemId: selectedItem.id,
      desc: newItem.desc || selectedItem.desc || "",
      quantity: newItem.quantity,
      rate: newItem.rate || selectedItem.price,
      tax: newItem.tax || 0,
    };

    const updatedServices = [...addedServices, added];
    setAddedServices(updatedServices);

    // Recalculate total
    recalculateTotal(updatedServices);

    setNewItem({ type: "", item: "", desc: "", quantity: 1, rate: 0, tax: 0 });
  };

  // When user selects a product
  const handleItemChange = (productId) => {
    // Find the selected product from itemsList
    const selectedProduct = itemsList.find((item) => item.id === productId);

    if (selectedProduct) {
      setNewItem({
        ...newItem,
        item: selectedProduct.id,
        desc: selectedProduct.desc || "",
        rate: selectedProduct.price || 0,
      });
    } else {
      // Reset if no product
      setNewItem({ ...newItem, item: "", desc: "", rate: 0 });
    }
  };

  // ---------------------------
  // Print Invoice
  // ---------------------------
  const printInvoice = () => {
    if (!reportRef.current) return;

    // Clone the content so we can remove inputs/selects without affecting the page
    const printContent = reportRef.current.cloneNode(true);

    // Remove all input/select elements inside cloned content
    printContent
      .querySelectorAll("input, select, button ,tfoot")
      .forEach((el) => el.remove());

    // Open new window
    const win = window.open("", "_blank");

    win.document.write(`
    <html>
      <head>
        <title>Invoice</title>
        <style>
          body { font-family: Arial; padding: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border:1px solid #ccc; padding:8px; font-size:13px; }
          th { background:#4CBC9A; color:#fff; }
          .signature { text-align:center; width:200px; border-top:1px solid #000; margin-top:40px; }
        </style>
      </head>
      <body>
        ${printContent.innerHTML}
      </body>
    </html>
  `);

    win.document.close();
    win.focus();
    win.print();
    win.close();
  };

  const saveAddedServices = async () => {
    if (!reservation) return;

    // if (addedServices.length === 0) {
    //   alert("No services to save!");
    //   return;
    // }

    try {
      // Prepare data to update
      const updatedData = {
        addedServices: addedServices, // save the full array
        totalServicesPrice: totalServicesPrice,
      };

      // Use your updateContent function
      await updateContent(
        "reservations", // collection name
        "", // folder for any images if needed
        reservation.id,
        updatedData
      );

      alert("Services saved successfully!");

      // Optionally, update local reservation state
      setReservation({
        ...reservation,
        addedServices: addedServices,
        totalServicesPrice: totalServicesPrice,
      });
    } catch (err) {
      console.error(err);
      alert("Failed to save services.");
    }
  };

  // ---------------------------
  // UI Loading
  // ---------------------------
  if (loading) return <div>Loading...</div>;
  if (!reservation) return <div>No booking found</div>;

  return (
    <div className="card invoice" style={{ padding: "30px" }}>
      <div
        style={{
          width: "80%",
          margin: "0 auto",
        }}
      >
        <div ref={reportRef}>
          {/* Hotel Info */}
          <div className="hotel-grid" style={{ display: "flex", gap: "20px" }}>
            <div className="hotel-grid-item1">
              <img
                src={reservation.image || ""}
                alt="Hotel"
                style={{
                  width: "100%",
                  maxHeight: "120px",
                  objectFit: "cover",
                }}
              />
            </div>
            <div className="hotel-grid-item2" style={{ flex: 2 }}>
              <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                {reservation.hotelName}
              </div>
              <div>{reservation.address}</div>
              <div>
                {reservation.phone} | {reservation.email}
              </div>
            </div>
          </div>

          {/* Guest Info */}
          <div
            className="guest-info"
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "25px",
              marginTop: "25px",
            }}
          >
            <div>
              <b>Billed To:</b>
              <div>
                {reservation.firstName} {reservation.lastName}
              </div>
              <div>{reservation.mobile}</div>
              <div>{reservation.email}</div>
              <div>{reservation.address}</div>
            </div>
            <div>
              <div>Check-in: {reservation.checkIn}</div>
              <div>Check-out: {reservation.checkOut}</div>
            </div>
          </div>

          {/* Charges Table */}
          <h6>Charges</h6>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Sr#</th>
                <th style={thStyle}>Type</th>
                <th style={thStyle}>Description</th>
                <th style={thStyle}>Quantity</th>
                <th style={thStyle}>Rate</th>
                <th style={thStyle}>Total</th>
                <th style={thStyle}>Tax</th>
                <th style={thStyle}>Action</th>
              </tr>
            </thead>

            <tbody>
              {reservation.roomDetails?.map((room, idx) => (
                <tr key={`room-${room.id || idx}`}>
                  <td style={tdStyle}>{idx + 1}</td>
                  <td style={tdStyle}>
                    {room.name} ({room.planName})
                  </td>
                  {/* <td style={tdStyle}>{room.quantity}</td> */}
                  <td style={tdStyle}>-</td>
                  <td style={tdStyle}>{reservation.noOfDays} Night</td>
                  <td style={tdStyle}>Rs {room.rate[0]?.ratePerNight} </td>
                  <td style={tdStyle}>Rs {room.roomTotalPrice}</td>
                  <td style={tdStyle}>Rs {room.roomTotalTax}</td>
                  <td style={tdStyle}>-</td>
                </tr>
              ))}

              {addedServices.map((s, idx) => (
                <tr key={`service-${s.type}-${s.item}-${idx}`}>
                  <td style={tdStyle}>
                    {idx + 1 + reservation.roomDetails.length}
                  </td>
                  <td style={tdStyle}>
                    {s.item} ({s.type})
                  </td>
                  {/* <td style={tdStyle}>{s.quantity}</td> */}
                  <td style={tdStyle}>{s.desc}</td>
                  <td style={tdStyle}>{s.quantity}</td>
                  <td style={tdStyle}>RS {s.rate}</td>
                  <td style={tdStyle}>RS {s.quantity * s.rate}</td>
                  <td style={tdStyle}>RS {s.tax}</td>
                  <td style={tdStyle}>
                    <button
                      style={{ ...buttonStyle, background: "#e74c3c" }}
                      onClick={() => {
                        const updated = [...addedServices];
                        updated.splice(idx, 1);
                        setAddedServices(updated);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr>
                <td style={tdStyle}>Add New</td>

                <td style={tdStyle}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <select
                      style={inputStyle}
                      value={newItem.type}
                      onChange={(e) => handleTypeChange(e.target.value)}
                    >
                      <option value="">Select Type</option>
                      {servicesTypes.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.type} {/* or type.desc if you want */}
                        </option>
                      ))}
                    </select>
                    <select
                      style={inputStyle}
                      value={newItem.item}
                      onChange={(e) => handleItemChange(e.target.value)}
                    >
                      <option value="">Select Item</option>
                      {itemsList.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </td>

                <td style={tdStyle}>
                  <input
                    type="text"
                    placeholder="Description"
                    value={newItem.desc}
                    onChange={(e) =>
                      setNewItem({ ...newItem, desc: e.target.value })
                    }
                    style={{ width: "100%", padding: "4px" }}
                  />
                </td>

                <td style={tdStyle}>
                  <input
                    type="number"
                    placeholder="Quantity"
                    value={newItem.quantity}
                    onChange={(e) =>
                      setNewItem({
                        ...newItem,
                        quantity: Number(e.target.value),
                      })
                    }
                    style={{ width: "80px", padding: "4px" }}
                  />
                </td>

                <td style={tdStyle}>
                  <input
                    type="number"
                    placeholder="Rate"
                    value={newItem.rate}
                    onChange={(e) =>
                      setNewItem({ ...newItem, rate: Number(e.target.value) })
                    }
                    style={{ width: "80px", padding: "4px" }}
                  />
                </td>

                <td style={tdStyle}>{newItem.quantity * newItem.rate}</td>

                <td style={tdStyle}>
                  <input
                    type="number"
                    placeholder="Tax"
                    value={newItem.tax}
                    onChange={(e) =>
                      setNewItem({ ...newItem, tax: Number(e.target.value) })
                    }
                    style={{ width: "80px", padding: "4px" }}
                  />
                </td>

                <td style={tdStyle}>
                  <button onClick={handleAddService} style={buttonStyle}>
                    Add
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>

          {/* Summary */}
          <div
            className="summary"
            style={{
              marginTop: "20px",
              fontWeight: "bold",
              float: "inline-end",
            }}
          >
            <div>Total Tax: Rs {reservation.taxes}</div>
            <div>Total Services: Rs {totalServicesPrice}</div>

            <div>
              Total Amount: Rs{" "}
              {Number(reservation.totalPrice) +
                Number(reservation.taxes) +
                Number(totalServicesPrice)}
            </div>
          </div>

          {/* Signature */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              marginTop: "150px",
            }}
          >
            <div style={signatureStyle}>Guest</div>
            <div style={signatureStyle}>Cashier</div>
          </div>
        </div>

        {/* PRINT BUTTON */}

        <div
          style={{
            width: "fit-content",
            margin: "120px auto",
            display: "flex",
            gap: "20px",
          }}
        >
          <button
            onClick={printInvoice}
            style={{
              padding: "10px 20px",
              background: "#4CBC9A",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Print Invoice
          </button>
          <button
            style={{
              padding: "10px 20px",
              background: "#4CBC9A",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
            onClick={saveAddedServices}
          >
            Save Services to DataBase
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingReportPage;
